import {Columns} from 'compob2b-table';
import {translations} from "../../../../../environments/translations.ru";
import {FormlyFieldConfig} from "@ngx-formly/core";

export const DAM_CATALOG_BATCH_FORM: Columns[] =
  [
    {
      key: 'forAll',
      title: translations.forAll,
      type: 'checkbox',
    },
    {
      key: 'operation',
      title: translations.operations,
      defaultValue: 'none',
      type: 'select',
      templateOptions: {
        label: translations.operations,
        options: [
          {label: translations.selectOperations, value: 'none'},
          {label: translations.makeEnabled, value: 'enable'},
          {label: translations.makeDisable, value: 'disable'},
          {label: translations.dam.toApproved, value: 'approved'},
          {label: translations.dam.notApproved, value: 'notApproved'},
          {label: translations.damChangeAcl, value: 'changeAcl'},
          {label: translations.changeCategory, value: 'category'},
        ],
      }
    },
    {
      key: 'deleteAction',
      title: translations.delete,
      type: 'checkbox',
      defaultValue: false,
      hideExpression: model => model.operation !== 'changeAcl'
    },
    {
      key: 'rolesName',
      title: translations.roles,
      placeholder: translations.roles,
      type: 'select',
      templateOptions: {
        label: translations.roles,
        type: 'array',
        valueProp: 'name',
        labelProp: 'header'
      },
      expressionProperties: {
        'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
          return model.operation === 'changeAcl';
        },
      },
      hideExpression: model => model.operation !== 'changeAcl'
    },
    {
      key: 'changeAclMode',
      title: translations.changeModesLabel,
      formly: true,
      defaultValue: 1,
      type: 'multicheckbox',
      templateOptions: {
        label: translations.changeModesLabel,
        options: [
          {label: translations.dam.read, value: 1},
          {label: translations.dam.write, value: 2},
          {label: translations.dam.administration, value: 16},
          {label: translations.dam.create, value: 4},
          {label: translations.dam.delete, value: 8},
        ],
      },
      hideExpression: model => model.operation !== 'changeAcl',
      expressionProperties: {
        'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
          return model.operation === 'changeAcl';
        },
      }
    },
    {
      key: 'catalogId',
      title: translations.catalog,
      formly: true,
      type: 'dam-catalog-picker',
      expressionProperties: {
        'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
          return model.operation === 'category';
        },
      },
      hideExpression: model => model.operation !== 'category'
    },

  ];
